import { useQuery } from "react-query";
import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";



const get96WellMetrics = async (plate_uuid) => {


    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qlp/qlp_metrics/${plate_uuid}`, {
        headers: headerConfig
    });

    return data;
};

export default function useFetchQlp96WellMetrics(plate_uuid) {


    return useQuery('96WellMetrics', () => get96WellMetrics(plate_uuid), {
        onSuccess: (data) => {
            //console.log(data);
        },

        onError: (error) => {
            //console.log(error);
        },

    });
};
